import { DEFAULT_LOCATIONS, CONTINENTAL_RESOURCES, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 0ba4fc3b55ef610541d71d7b1ca10b77eae62564',
  staging: 'Token 62b471a106e75992a1112c96700d538d886a8f4c',
  prod: 'Token e9038e04ff8a978a1fb1c7d53d6519f0785a049e',
};

const token = selectToken(apiTokens);

const clrConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'continental',

  API_TOKEN: token,
  EMBOLD_CLIENT: CONTINENTAL_RESOURCES,

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.OklahomaCity },
  LOGIN_NETWORK_NAME: 'clrUserId',

  // content
  DISPLAY_NAME: 'Continental Resources',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default clrConfig;
